module.exports = __webpack_public_path__ + "static/media/edit.6ef118dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/edit.svg
// module id = 757
// module chunks = 0